import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const approvalWorkflowApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getApprovalWorkflows: builder.mutation({
      query: (data) => ({
        url: `/mckesson/getapprovalworkflows?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    createApprovalWorkflow: builder.mutation({
      query: (data) => ({
        url: "/approvalworkflow/create",
        method: "POST",
        body: data,
      }),
    }),
    editApprovalWorkflow: builder.mutation({
      query: (data) => ({
        url: "/mckesson/putapprovalworkflow",
        method: "PUT",
        body: data,
      }),
    }),
    getApprovalWorkflowById: builder.mutation({
      query: (id) => ({
        url: `/mckesson/getapprovalworkflowbyid?id=${id}`,
        method: "GET",
      }),
    }),
    deleteApprovalWorkflow: builder.mutation({
      query: (data) => ({
        url: `/approvalworkflow/delete?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    getApprovalModes: builder.mutation({
      query: () => ({
        url: `/mckesson/getapprovalmodes`,
        method: "GET",
      }),
    }),
    duplicateApprovalWorkflow: builder.mutation({
      query: (data) => ({
        url: `/approvalworkflow/duplicate?${getFilters(data)}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetApprovalWorkflowsMutation,
  useCreateApprovalWorkflowMutation,
  useEditApprovalWorkflowMutation,
  useGetApprovalWorkflowByIdMutation,
  useDeleteApprovalWorkflowMutation,
  useGetApprovalModesMutation,
  useDuplicateApprovalWorkflowMutation,
} = approvalWorkflowApiSlice;
